// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var StringUtils = require("../../../shared/src/StringUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var BasicInfo = {};

var Details = {};

var $$Location = {};

function toString(param) {
  return StringUtils.leftPad("0", 2, Relude_Float.toString(param.hours)) + (":" + StringUtils.leftPad("0", 2, Relude_Float.toString(param.minutes)));
}

function validHourValue(maybeHourValue) {
  if (Curry._3(Relude_Float.between, 0.0, 23.0, maybeHourValue)) {
    return Relude_Option.pure(maybeHourValue);
  }
  
}

function validMinuteValue(maybeMinuteValue) {
  if (Curry._3(Relude_Float.between, 0.0, 59.0, maybeMinuteValue)) {
    return Relude_Option.pure(maybeMinuteValue);
  }
  
}

function fromString(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_String.splitArray(":", param);
                            }), (function (param) {
                              if (param.length !== 2) {
                                return ;
                              }
                              var hoursStr = param[0];
                              var minutesStr = param[1];
                              return Curry._2(Relude_Option.tuple2, Curry._2(Relude_Option.flatMap, validHourValue, Relude_Float.fromString(hoursStr)), Curry._2(Relude_Option.flatMap, validMinuteValue, Relude_Float.fromString(minutesStr)));
                            }), param);
              }), (function (param) {
                return Relude_Option.map((function (param) {
                              return {
                                      hours: param[0],
                                      minutes: param[1]
                                    };
                            }), param);
              }), param);
}

function compare(a, b) {
  var b$1 = b.hours;
  var a$1 = a.hours;
  if (Relude_Float.approximatelyEqual(0.0001, a$1, b$1)) {
    return Curry._2(Relude_Float.compare, a.minutes, b.minutes);
  } else {
    return Curry._2(Relude_Float.compare, a$1, b$1);
  }
}

function eq(a, b) {
  return compare(a, b) === "equal_to";
}

var ShiftTime = {
  toString: toString,
  validHourValue: validHourValue,
  validMinuteValue: validMinuteValue,
  fromString: fromString,
  compare: compare,
  eq: eq
};

function makeShiftDate($staropt$star, timezone, param, date) {
  var isNextDay = $staropt$star !== undefined ? $staropt$star : false;
  return DateUtils.getJsDateInForcedTimezone(timezone)(new Date(date.getFullYear(), date.getMonth(), isNextDay ? date.getDate() + 1.0 : date.getDate(), param.hours, param.minutes));
}

function makeShiftDates(param) {
  var timezone = param.timezone;
  var endTime = param.endTime;
  var startTime = param.startTime;
  return Curry._2(Relude_Array.map, (function (date) {
                return {
                        startDatetime: makeShiftDate(undefined, timezone, startTime, date),
                        endDatetime: makeShiftDate(compare(endTime, startTime) !== "greater_than", timezone, endTime, date)
                      };
              }), param.dates);
}

var Dates = {
  ShiftTime: ShiftTime,
  makeShiftDate: makeShiftDate,
  makeShiftDates: makeShiftDates
};

exports.BasicInfo = BasicInfo;
exports.Details = Details;
exports.$$Location = $$Location;
exports.Dates = Dates;
/* DateUtils Not a pure module */
